/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-06-06 10:16:16
 * @LastEditors: liangen liangen@oppo.com
 * @LastEditTime: 2022-08-16 16:24:35
 * @FilePath: /cem-portal-frontend/src/utils/utils.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Message } from '@gcommon/gcommon-ui'
import { useDispatch, useSelector } from './bhooks'
import i18n from '@/locales'

export function getQueryString(key) {
  let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  let res = window.location.search.substr(1).match(reg)
  if (res != null) return unescape(res[2])
  return null
}

/**
 * @description 用于get请求拼接入参
 * @param paramsObj 参数object
 * @param pickParams 摘取个别入参
 * @returns
 */
export function getParmeterSplic(paramsObj = {}, pickParams = []) {
  let paramsStr = ''
  let paramsArr = !!pickParams?.length ? pickParams : Object.keys(paramsObj)
  let len = paramsArr.length
  paramsArr.forEach((param, i) => {
    paramsStr += param + '=' + paramsObj[param] + (i != len - 1 ? '&' : '')
  })
  return paramsStr
}

/**
 *
 * @param time 时间戳
 * @returns
 */
export const getTime = (time) => {
  let index = time?.indexOf('.')
  return index >= 0 ? time.substring(0, index) : time
}

/*
  获取随机数
*/
export const getKey = () => {
  return new Date().getTime().toString() + Math.random().toString()
}
/**
 *
 * @param p promise
 * @param msg 操作信息
 * @param cb 操作后的回调函数
 */
export const asyncCallback = (
  p,
  msg = '',
  cb = (data = {}) => {},
  isNeed = false
) => {
  const tran = function (initParam) {
    return i18n.t(initParam) as string
  }
  p.then((res) => {
    if (res.code == 200) {
      if (isNeed && !res.data) {
        Message({
          message: `${msg}${tran('common.success')}`,
          type: 'success'
        })
      }
      if (!isNeed) {
        Message({
          message: `${msg}${tran('common.success')}`,
          type: 'success'
        })
      }

      if (isNeed) {
        cb(res)
      } else {
        cb()
      }
    } else {
      Message({
        message: res.msg,
        type: 'warning'
      })
    }
  }).catch((err) => {
    Message({
      message: `${msg}${tran('common.fail')}`,
      type: 'error'
    })
  })
}

/**
 *
 * @param p promise
 * @param msg 操作信息
 * @param cb 操作后的回调函数
 */
export const asyncCallbackMessageBox = (
  p,
  msg = '',
  cb = (data = {}) => {},
  isNeed = false
) => {
  const tran = function (initParam) {
    return i18n.t(initParam) as string
  }
  p.then((res) => {
    if (res.code == 200) {
      if (isNeed && !res.data) {
        Message({
          message: `${msg}${tran('common.success')}`,
          type: 'success'
        })
      }
      if (!isNeed) {
        Message({
          message: `${msg}${tran('common.success')}`,
          type: 'success'
        })
      }

      if (isNeed) {
        cb(res)
      } else {
        cb()
      }
    }
  }).catch((err) => {
    Message({
      message: `${msg}${tran('common.fail')}`,
      type: 'error'
    })
  })
}

/**
 *
 * @returns 对应时辰
 */
export const getHour = () => {
  let hour = new Date().getHours()
  if (hour >= 0 && hour <= 12) {
    return 'greetMor'
  } else if (hour > 12 && hour <= 18) {
    return 'greetAft'
  } else {
    return 'greetEve'
  }
}

export const isNull = (val) => {
  if (val || val === 0) {
    return false
  } else {
    return true
  }
}

/**
 * 四舍五入保留小数位 => 基数被放大100倍
 * @param {*} num 基数
 * @param {*} decimal  小数位
 * @returns
 */
export const mathRound = (num, decimal) => {
  if (isNull(num)) {
    return num
  }
  let nums =
    Math.round(parseFloat(num) * Math.pow(10, decimal + 2)) /
    Math.pow(10, decimal)
  return nums.toFixed(2)
}

//特殊错误码
export const getErrorCode = (code) => {
  const tran = function (initParam) {
    return i18n.t(initParam) as string
  }
  const codeObj = {
    5001: tran('wrongCode.code5001'),
    5002: tran('wrongCode.code5002'),
    5003: tran('wrongCode.code5003'),
    5004: tran('wrongCode.code5004'),
    5005: tran('wrongCode.code5005'),
    5006: tran('wrongCode.code5006'),
    5007: tran('wrongCode.code5007'),
    5008: tran('wrongCode.code5008'),
    5009: tran('wrongCode.code5009'),
    5010: tran('wrongCode.code5010'),
    5011: tran('wrongCode.code5011'),
    5012: tran('wrongCode.code5012'),
    5101: tran('wrongCode.code5101'),
    5102: tran('wrongCode.code5102'),
    5103: tran('wrongCode.code5103'),
    5104: tran('wrongCode.code5104'),
    5105: tran('wrongCode.code5105'),
    5106: tran('wrongCode.code5106'),
    5107: tran('wrongCode.code5107'),
    5108: tran('wrongCode.code5108'),
    5109: tran('wrongCode.code5109'),
    5110: tran('wrongCode.code5110'),
    5111: tran('wrongCode.code5111'),
    5113: tran('wrongCode.code5113'),
    5114: tran('wrongCode.code5114'),
    5115: tran('wrongCode.code5115'),
    // 5116: tran('wrongCode.code5116'),
    404: tran('wrongCode.code404'),
    5201: tran('wrongCode.code5201'),
    5202: tran('wrongCode.code5202'),
    5203: tran('wrongCode.code5203'),
    5204: tran('wrongCode.code5204'),
    5205: tran('wrongCode.code5205'),
    5206: tran('wrongCode.code5206'),
    5223: tran('wrongCode.code5223'),
    5207: tran('wrongCode.code5207'),
    5208: tran('wrongCode.code5208'),
    5209: tran('wrongCode.code5209'),
    5210: tran('wrongCode.code5210'),
    5211: tran('wrongCode.code5211'),
    5212: tran('wrongCode.code5212'),
    5213: tran('wrongCode.code5213'),
    5224: tran('wrongCode.code5224'),
    5215: tran('wrongCode.code5215'),
    5216: tran('wrongCode.code5216'),
    5220: tran('wrongCode.code5221'),
    5222: tran('wrongCode.code5222'),
    5225: tran('wrongCode.code5225'),
    5226: tran('wrongCode.code5226'),
    5227: tran('wrongCode.code5227'),
    5228: tran('wrongCode.code5228'),
    5229: tran('wrongCode.code5229'),
    5230: tran('wrongCode.code5230'),
    5231: tran('wrongCode.code5231'),
    5232: tran('wrongCode.code5232'),
    5233: tran('wrongCode.code5233'),
    5234: tran('wrongCode.code5234'),
    5235: tran('wrongCode.code5235'),
    5236: tran('wrongCode.code5236'),
    5237: tran('wrongCode.code5237'),
    5238: tran('wrongCode.code5238'),
    5239: tran('wrongCode.code5239'),
    5240: tran('wrongCode.code5240'),
    5241: tran('wrongCode.code5241'),
    5242: tran('wrongCode.code5242'),
    5243: tran('wrongCode.code5243'),
    5244: tran('wrongCode.code5244'),
    5245: tran('wrongCode.code5245'),
    5246: tran('wrongCode.code5246'),
    5247: tran('wrongCode.code5247'),
    5248: tran('wrongCode.code5248'),
    30000: tran('wrongCode.code30000'),
    30001: tran('wrongCode.code30001'),
    30002: tran('wrongCode.code30002'),
    30003: tran('wrongCode.code30003'),
    30004: tran('wrongCode.code30004'),
    30005: tran('wrongCode.code30005'),
    30006: tran('wrongCode.code30006'),
    30033: tran('wrongCode.code30033'),
    30007: tran('wrongCode.code30007'),
    30008: tran('wrongCode.code30008'),
    30009: tran('wrongCode.code30009'),
    30010: tran('wrongCode.code30010'),
    30011: tran('wrongCode.code30011'),
    30012: tran('wrongCode.code30012'),
    30013: tran('wrongCode.code30013'),
    30014: tran('wrongCode.code30014'),
    30015: tran('wrongCode.code30015'),
    30016: tran('wrongCode.code30016'),
    30017: tran('wrongCode.code30017'),
    30018: tran('wrongCode.code30018'),
    30019: tran('wrongCode.code30019'),
    30020: tran('wrongCode.code30020'),
    30021: tran('wrongCode.code30021'),
    30022: tran('wrongCode.code30022'),
    30023: tran('wrongCode.code30023')
  }
  return codeObj[code]
}

//不需要错误提示的
export const NOT_NEED_ERROR_TIPS_TYPE = [
  5011, 5013, 30024, 30025, 30026, 30027, 30028, 30029, 30030, 30031, 30032
]

//删除错误码
export const DELETE_ERROR_TYPE = [5004, 5005, 5006, 5007, 5008, 5110, 5111]

//获取表格的高度
export const getTableHight = (ref, padding) => {
  // return 300
  const height = ref?.offsetHeight
  // return height
  return height ? height - padding : height
}

// 处理占比数据超过100%
export const handleProportionData = (list) => {
  list.reduce((total, current, index) => {
    total += current
    if (total >= 100) {
      const val = 100 - (total - current)
      // list[index] = val >= 0 ? val : 0
      list[index] = val >= 0 ? +val.toFixed(2) : 0
    } else if (total < 100 && index + 1 === list.length - 1) {
      list[list.length - 1] = +(100 - total).toFixed(2) // 调整精度
    }
    return total
  }, 0)
}

// 删除url中某个参数
export const funcUrlDel = (name) => {
  let loca = window.location
  let baseUrl = loca.origin + loca.pathname + '?'
  let query = loca.search.substr(1)
  if (query.indexOf(name) > -1) {
    let obj = {}
    let arr = query.split('&')
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=')
      obj[arr[i][0]] = arr[i][1]
    }
    delete obj[name]
    let url =
      baseUrl +
      JSON.stringify(obj)
        .replace(/[\"\{\}]/g, '')
        .replace(/\:/g, '=')
        .replace(/\,/g, '&')
    return url
  }
}
export const getBlob = (url) => {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response)
      }
    }
    xhr.send()
  })
}
export const saveAs = (blob, filename) => {
  if (window.navigator?.msSaveOrOpenBlob) {
    navigator?.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    const body = document.querySelector('body')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.style.display = 'none'
    body.appendChild(link)
    link.click()
    body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  }
}

export const getSurveyDomain = (isolationCode) => {
  const domain = window?.env.PASSIVE_RESEARCH_DOMAIN
  if (typeof domain === 'object') {
    // 表示印度配置
    return domain[isolationCode]
  } else {
    return domain // 表示其他站点配置
  }
}

//生成uuid
export function generateUUID() {
  let uuid = generateUUID1()
  if (!uuid || uuid === 'null') {
    uuid = generateUUID2()
  }
  return uuid
}

// 生成uuid1
function generateUUID1() {
  let d = new Date().getTime() //Timestamp
  let d2 = (performance && performance.now && performance.now() * 1000) || 0 //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0
      d = Math.floor(d / 16)
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0
      d2 = Math.floor(d2 / 16)
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

// 生成uuid2
function generateUUID2() {
  const timestamp = Date.now().toString(16)
  const random = Math.random().toString(16).slice(2)
  return `${timestamp}-${random}`
}
